import React, { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import { handleError } from "../../../utils/handleError.js";
import { trimTableData, organizeTableUnits } from "./utils/tableUtils.js";
import cleanTableCellTextToCopy from "./utils/cleanTableCellTextToCopy.js";
import ReferenceWrapper from "@/components/ReferenceWrapper";

function ChatTableV2({ tableData, sourceRef, level, qid }) {
  let { data, headers } = tableData;
  if (data.length === 0) {
    return;
  }

  let headersChangeMap = {};

  ({ data, headersChangeMap } = organizeTableUnits(data, headers));

  if (!headersChangeMap) {
    headersChangeMap = {};
    headers.forEach((header) => {
      headersChangeMap[header] = header;
    });
  }

  const trimmedTableData = trimTableData(data);
  const [showTableInfo, setShowTableInfo] = useState(false);

  // console.log("ChatTableV2 -> data", data);
  // console.log("ChatTableV2 -> trimmedTableData", trimmedTableData);

  const trimmedTableDataIsDifferent =
    JSON.stringify(trimmedTableData) !== JSON.stringify(data);

  const trimmedHeaders = headers;
  const nCols = headers.length;
  const nTrimmedCols = trimmedHeaders.length;

  const styles = {
    container: {
      position: "relative",
      border: "1px solid #999", // Style for the box
      borderRadius: "5px",
      overflow: "hidden",
    },
    copyIcon: {
      position: "absolute",
      top: "10px",
      right: "10px",
      backgroundColor: "#fff",
      borderRadius: "50%",
      padding: "5px",
      cursor: "pointer",
      zIndex: 1,
    },
    evenRow: {
      backgroundColor: "#f2f2f2",
    },
  };

  const toggleShowInfo = () => setShowTableInfo(!showTableInfo);

  const handleCopy = async () => {
    try {
      // console.log(trimmedTableData);
      const data = JSON.parse(JSON.stringify(trimmedTableData));
      const columnHasTab = [];
      for (const rowIndex in data) {
        for (const colIndex in data[rowIndex]) {
          const newCellData = cleanTableCellTextToCopy(
            data[rowIndex][colIndex]
          );
          if (newCellData.includes("\t") && !columnHasTab.includes(colIndex)) {
            columnHasTab.push(colIndex);
          }

          if (columnHasTab.includes(colIndex) && !newCellData.includes("\t")) {
            data[rowIndex][colIndex] = newCellData + "\t";
          } else data[rowIndex][colIndex] = newCellData;
        }
      }

      const rows = data
        .map((row) => {
          const rowStr = headers
            .map((header) => row[headersChangeMap[header]])
            .join("\t");
          if (rowStr.endsWith("\t")) {
            return rowStr.slice(0, -1);
          }
          return rowStr;
        })
        .join("\n");

      let headersRow = "";
      // const headersRow = trimmedHeaders.join("\t");
      for (let header of trimmedHeaders) {
        if (header.includes("_headerId_"))
          header = header.split("_headerId_")[1];
        if (
          columnHasTab.includes(header) ||
          columnHasTab.includes(headersChangeMap[header])
        ) {
          headersRow += `${header}\t\t`;
        } else {
          headersRow += `${header}\t`;
        }
      }

      // if tab is present at end remove it from rows and headers
      if (headersRow.endsWith("\t")) {
        headersRow = headersRow.slice(0, -1);
      }

      await navigator.clipboard.writeText(`${headersRow}\n${rows}`);
      openFpToast("Copied the table to the clipboard", "success");
    } catch (error) {
      handleError({
        error,
        message: "Error copying table",
        tableData: trimmedTableData,
      });
    }
  };

  const getHeaderStr = (header) => {
    header = headersChangeMap[header] || header;

    if (header.includes("_headerId_")) {
      return header.split("_headerId_")[1];
    }

    return header;
  };

  return (
    <div className="w-full flex flex-col items- overflow-auto my-4 text-[12px]">
      <div
        className="mx-auto w-fit"
        style={{
          fontFamily: "monospace",
        }}
      >
        <div className="w-full flex justify-start">
          {/* Toggle button for showing table info */}
          {trimmedTableDataIsDifferent && (
            <button
              className={`p-1 px-2 text-[9px] cursor-pointer rounded-t-md mr-2 ${showTableInfo ? "bg-blue-500 text-white" : "bg-gray-500 text-white"}`}
              onClick={toggleShowInfo}
            >
              Show Details
            </button>
          )}

          <span
            className="bg-gray-500 text-white p-1 px-2 text-[9px] cursor-pointer rounded-t-md"
            onClick={handleCopy}
          >
            <ContentCopyIcon style={{ fontSize: "12px" }} />
            <span className="ml-2">Copy Table</span>
          </span>
        </div>

        <table className="border min-w-[400px]">
          <thead>
            <tr className="border bg-gray-600 text-white ">
              {showTableInfo
                ? headers.map((header, i) => (
                    <th key={i} className="p-2 border">
                      <strong>{getHeaderStr(header)}</strong>
                    </th>
                  ))
                : trimmedHeaders.map((header, i) => (
                    <th key={i} className="p-2 border">
                      <strong>{getHeaderStr(header)}</strong>
                    </th>
                  ))}
            </tr>
          </thead>
          <tbody>
            {showTableInfo
              ? data.map((row, i) => (
                  <tr key={i} style={i % 2 === 0 ? styles.evenRow : null}>
                    {headers.map((header, j) => (
                      <td
                        key={i * nCols + j}
                        className={`p-2 border-l  hover:bg-gray-200 transition-all`}
                      >
                        {level === 1 ? (
                          <span>{row[headersChangeMap[header]]}</span>
                        ) : (
                          <ReferenceWrapper
                            text={row[headersChangeMap[header]]}
                            sourceMap={sourceRef}
                            qid={qid}
                          />
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              : trimmedTableData.map((row, i) => (
                  <tr key={i} style={i % 2 === 0 ? styles.evenRow : null}>
                    {trimmedHeaders.map((header, j) => (
                      <td
                        key={i * nTrimmedCols + j}
                        className={`p-2 border-l hover:bg-gray-200 transition-all`}
                      >
                        {level === 1 ? (
                          <span>{row[headersChangeMap[header]]}</span>
                        ) : (
                          <ReferenceWrapper
                            text={row[headersChangeMap[header]]}
                            sourceMap={sourceRef}
                            qid={qid}
                          />
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ChatTableV2;
